import React, { useEffect } from 'react';
import { useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import {AiOutlinePlus,AiOutlineSave} from 'react-icons/ai';
import '../../../../../CSS/Dashboard/portfolio.scss';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useParams } from 'react-router';
import { fetchData, postData } from '../../../../../Utility/GlobalService';
import Carousel from './Components/Carousel';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

const PortfolioEdit = ()=>{
    const [refresh,setRefreshValue] = useState(false);
    const {id} = useParams();
    const [projectId,setProjectId] = useState("");
    const [stack,setStackValue] = useState("");
    const [name,setProjectName] = useState("");
    const [portfolioImageList,setPortfolioImagesList] = useState([]);
    const [portfolioImage,setPortfolioImage] = useState([]);
    const [live_link,setLiveLink] = useState("");
    const [portfolioDescription,setPortfolioDescription] = useState("");
    const [technology,setTechnologyValue] = useState("");
    const [technologyList,setTechnologyListValue] = useState([]);
    const [loading,setLoadingState] = useState(true);
    useEffect(async()=>{
        const data = await fetchData(`${getUrl()}/work/${id}`);
        // console.log(data);
        setProjectId(data._id);
        setStackValue(data.stack);
        setProjectName(data.projectname);
        setTechnologyListValue(data.technologies);
        setPortfolioDescription(data.description);
        setLiveLink(data.livelink);
        setPortfolioImagesList(data.images);
        setRefreshValue(false);
        setLoadingState(false);
    },[refresh]);

    const addImage = async()=>{
        setLoadingState(true);
        const data = new FormData();
        data.append('_id',projectId);
        data.append('workImage',portfolioImage);
        const response = await postData(`${getUrl()}/work/add/image`,data,'Do you want to this image?');
        if (response) setRefreshValue(true);
        setPortfolioImage("");
    }
    const addTechnology = async()=>{
        const data = {
            _id: projectId,
            name: technology
        }
        const response = await postData(`${getUrl()}/work/add/technology`,data,'Do you want to remove this item?');
        if (response) setRefreshValue(true);
        setTechnologyValue("");
    }
    const removeTechnology = async(id)=>{
        const data = {
            _id: projectId,
            id
        }
        const response = await postData(`${getUrl()}/work/remove/technology`,data,'Do you want to remove this item?');
        if(response) setRefreshValue(true);
    }

    const updateProjectName = async()=>{
        const data = {
            _id: projectId,
            name
        }
        const response = await postData(`${getUrl()}/work/update/name`,data,'Do you want to update project name?');
        if(response) setRefreshValue(true);
    }

    const updateProjectStack = async()=>{
        const data = {
            _id: projectId,
            stack
        }
        const response = await postData(`${getUrl()}/work/update/stack`,data, 'Do you want to update project stack?');
        if(response) setRefreshValue(true);
    }

    const updateProjectDescription = async()=>{
        const data = {
            _id: projectId,
            description: portfolioDescription
        }
        const response = await postData(`${getUrl()}/work/update/description`,data,'Do you want to update project description?');
        if(response) setRefreshValue(true);
    }
    const updateUrl = async()=>{
        const data = {
            _id: projectId,
            livelink: live_link
        }
        const response = await postData(`${getUrl()}/work/update/url`,data, 'Do you want to update project live link?');
        if(response) setRefreshValue(true);
    }

    const handleFormSubmit = (event)=>{
        event.preventDefault();
        // console.log('You Clicked');
        console.log(`Portfolio Stack: ${stack}`);
        console.log(`Live Link: ${live_link}`);
        console.log(portfolioImageList);
        console.log(technologyList);
        console.log(`Portfolio Description: ${portfolioDescription}`);
    }
    return (<div className="card mb-5">
            <div className="card-body mb-auto">
                <h5>Edit Portfolio</h5>
                <Carousel 
                images={portfolioImageList}/>
                {loading && <p className="mt-5">Please Wait while your file is being uploaded</p>}
                <form onSubmit = {handleFormSubmit}>
                    <div className="row mt-5">
                        <div className="col-md-4">
                        <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Name</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                              <input 
                                                required
                                                value = {name}
                                                onChange = {(event)=>{setProjectName(event.target.value)}}
                                                type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                            type = "button"
                                            onClick={updateProjectName}
                                            className="btn btn-sm btn-block btn-success">
                                                <AiOutlineSave 
                                                style={{width: '20px',height: '20px'}}
                                                className="icon"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Stack</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                              <input 
                                                required
                                                value = {stack}
                                                onChange = {(event)=>{setStackValue(event.target.value)}}
                                                type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                            type = "button"
                                            onClick={updateProjectStack}
                                            className="btn btn-sm btn-block btn-success">
                                                <AiOutlineSave 
                                                style={{width: '20px',height: '20px'}}
                                                className="icon"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Image</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                            <input 
                                            required
                                            onChange = {(event)=>{setPortfolioImage(event.target.files[0])}}
                                            type="file" 
                                            className="form-control" />
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                                type = "button"
                                                onClick={addImage}
                                                className="btn btn-sm btn-block btn-success">
                                                    <AiOutlineSave 
                                                    style={{width: '20px',height: '20px'}}
                                                    className="icon"/>
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Technology</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                            <input 
                                                required
                                                value = {technology}
                                                onChange = {(event)=>{setTechnologyValue(event.target.value)}}
                                                type="text" 
                                                className="form-control"/>
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                            type = "button"
                                            onClick={addTechnology}
                                            className="btn btn-sm btn-block btn-success">
                                                <AiOutlinePlus 
                                                style={{width: '20px',height: '20px'}}
                                                className="icon"/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-10">
                                            <div className="technology-list">
                                                <div className="item">
                                                {technologyList && technologyList.map((data)=> 
                                                    // {console.log(data)}
                                                    {return(
                                                    <p 
                                                        onClick = {()=>{removeTechnology(data._id)}}
                                                        key = {data._id}
                                                        className="item-content">{data.name}</p>)}
                                                    
                                                )} 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="">Live Link</label>
                                    <div className="row">
                                        <div className="col-md-9">
                                            <input 
                                            required
                                            value = {live_link}
                                            onChange = {(event)=>{setLiveLink(event.target.value)}}
                                            type="url" 
                                            className="form-control" />
                                        </div>
                                        <div className="col-md-3">
                                            <button 
                                                type = "button"
                                                onClick={updateUrl}
                                                className="btn btn-sm btn-block btn-success">
                                                    <AiOutlineSave 
                                                    style={{width: '20px',height: '20px'}}
                                                    className="icon"/>
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <label htmlFor="">Description</label>
                            {/* <input type="textarea" row="10" className="form-control" /> */}
                            <CKEditor
                                editor={ ClassicEditor }
                                data={portfolioDescription}
                                onReady={ editor => {
                                    // You can store the "editor" and use when it is needed.
                                    console.log( 'Editor is ready to use!', editor );
                                } }
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setPortfolioDescription(data);
                                    // console.log( { event, editor, data } );
                                } }
                            />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <button type="button"
                            onClick = {updateProjectDescription} 
                            className="btn btn-sm btn-block btn-success">
                                Update Description
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default PortfolioEdit;